import { fetchAPI } from "./baseApi";

export async function getMembersAdmin() {
  return fetchAPI("/members/admin", { method: "GET" });
}

export async function createMember(data) {
  return fetchAPI("/members/admin", {
    method: "POST",
    body: JSON.stringify(data),
  });
}

export async function updateMember(id, data) {
  return fetchAPI(`/members/admin/${id}`, {
    method: "PUT",
    body: JSON.stringify(data),
  });
}

export async function deleteMember(id) {
  return fetchAPI(`/members/admin/${id}`, { method: "DELETE" });
}
